export class GetTableDataQualityProfileResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "partitionBy",
            "baseName": "partitionBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordCount",
            "baseName": "recordCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "commitAgeSeconds",
            "baseName": "commitAgeSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "lagSeconds",
            "baseName": "lagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<TableColumnProfile>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityProfileResponse.attributeTypeMap;
    }
    constructor() {
    }
}
